import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b79f3064"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-flex tw-gap-[40px] tw-flex-col tw-h-auto tw-p-[15px] tw-mt-[25px]" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-items-start tw-pr-[35px] tw-gap-[12px]" }
const _hoisted_3 = { class: "tw-text-[#211f58] tw-text-[18px] tw-font-medium tw-leading-[145%] title" }
const _hoisted_4 = { class: "tw-text-[#878787] tw-text-[14px] tw-font-normal tw-leading-[140%] sub-title" }

import { ref } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import stepToSolve from "@/components/recommend/editActionModalElement/stepToSolve.vue";
import ButtonAddAnother from "../wizard/buttonAddAnother.vue";
import { IModalMessage } from "@/interfaces/common/common";
import { MODAL_NAME } from "@/utils/constants";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";


export default /*#__PURE__*/_defineComponent({
  __name: 'stepToSolveDetailActionTab',
  props: {
  data: {
    type: Object as () => any,
    required: false,
    default: null,
  },
},
  setup(__props) {

const props = __props;



const isCheckListStep = ref(false);

const addStep = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMENDATION_EDIT_ACTIONS,
    properties: {
      action: props.data.item,
      isEditActionTable: true,
      shouldScrollToBottom: true,
    },
  };
  eventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
            "app-assess-recommendations-action-table-label-tab-action-plan-1",
          )), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
            "app-assess-recommendations-action-table-steps-solve-sub-title-1",
          )), 1)
    ]),
    _createElementVNode("div", null, [
      _createVNode(stepToSolve, {
        "check-list-group-id": __props.data.item.checklistGroupId,
        "check-list-group-template-id": __props.data.item.checklistGroupTemplateId,
        disable: true,
        onIsCheckListStep: _cache[0] || (_cache[0] = ($event: any) => (isCheckListStep.value = $event))
      }, null, 8, ["check-list-group-id", "check-list-group-template-id"]),
      (!__props.data.item.isSuggested)
        ? (_openBlock(), _createBlock(ButtonAddAnother, {
            key: 0,
            "style-button": '!tw-border-transparent !tw-shadow-none',
            onClick: addStep
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(isCheckListStep.value
            ? _unref(getComponentUiText)(
                "app-assess-recommendations-edit-action-modal-add-step-to-solve-1",
              )
            : _unref(getComponentUiText)(
                "app-assess-recommendations-edit-action-modal-add-task-other-1",
              )), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})